import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** Null when the build has no mygaz-dev URL and key (a fork, a design preview): the console then offers the demo. */
export const supabase: SupabaseClient | null = url && key ? createClient(url, key, { auth: { persistSession: true, storageKey: 'mygaz-ops-auth' } }) : null;
